// components/Seo.tsx — per-page SEO (title, description, canonical, OG/Twitter, JSON-LD) (spec §4.5).
import { Helmet } from 'react-helmet-async';
import { OG_IMAGE, SITE_URL } from '../lib/seo';

type JsonLd = Record<string, unknown>;

export interface SeoProps {
  title: string;
  description: string;
  path?: string;
  type?: 'website' | 'article';
  image?: string;
  /** One or more schema.org JSON-LD blocks. */
  jsonLd?: JsonLd | JsonLd[];
}

export function Seo({
  title,
  description,
  path = '/',
  type = 'website',
  image = OG_IMAGE,
  jsonLd,
}: SeoProps) {
  const url = `${SITE_URL}${path}`;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="UPLOAD" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {blocks.map((block, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  );
}
